import { Rule } from '../rule'
import { uuid } from '../uuid'
import { DependOnOption, DisabledType } from '../common'

export class CustomDef {
  key?: string = uuid()
  type: 'custom' = 'custom'
  customType!: string
  model!: string
  label!: string
  dependOn?: DependOnOption
  options?: CustomOptions = new CustomOptions()
  rules?: Rule[]
}

export class CustomOptions {
  defaultValue?: any
  disabled?: DisabledType = false
  labelWidth?: string | number
  required?: boolean = false;
  [key: string]: any
}
